<div class="table-container">
  <div class="row-container" [ngClass]="{'header': row.type === 'header'}" *ngFor="let row of rows">
    <div  *ngFor="let cell of row.data">
      <div class="cell">{{cell | translate}}</div>
    </div>
  </div>
</div>
